<template>
  <div>
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteItem" />

    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? `${$t('common.add')} ${$t('office.tour')}`
          : `${$t('common.edit')} ${$t('office.tour')}`
      "
      @ok="submitItem()"
    >
      <b-card-text>
        <b-row>
          <b-col md="4" cols="12">
            <b-form-group :label="$t('common.type')" label-for="status">
              <v-select
                v-model="EditForm.type"
                :options="[
                  {
                    text: $t('office.morning'),
                    value: 'morning',
                  },
                  { text: $t('office.night'), value: 'night' },
                ]"
                label="text"
                :reduce="(action) => action.value"
                :placeholder="$t('common.type')"
              />
            </b-form-group>
          </b-col>

          <b-col md="4" cols="12">
            <b-form-group :label="$t('common.content')" label-for="value">
              <b-form-textarea
                id="note"
                v-model="EditForm.content"
                :placeholder="$t('common.content')"
              />
            </b-form-group>
          </b-col>
          <b-col md="4" cols="12">
            <b-form-group :label="$t('common.date')" label-for="date">
              <datetime
                input-class="form-control"
                type="datetime"
                v-model="date"
                :disabled="true"
              >
              </datetime>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <b-card :title="$t('office.follow-up')">
      <div>
        <b-row>
          <b-col cols="12" md="12">
            <h2>{{ $t('common.filter') }} {{ $t('office.tours') }}</h2>
            <br />
          </b-col>

          <b-col md="4" cols="12">
            <b-form-group :label="$t('common.type')" label-for="Name">
              <v-select
                v-model="EditForm.type"
                :options="[
                  {
                    text: $t('office.morning'),
                    value: 'morning',
                  },
                  { text: $t('office.night'), value: 'night' },
                ]"
                label="text"
                :reduce="(action) => action.value"
                :placeholder="$t('common.type')"
              />
            </b-form-group>
          </b-col>
          <b-col md="4" cols="12">
            <b-form-group :label="$t('common.date')" label-for="Name">
              <datepicker
                v-model="dateFilter"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2"
                placeholder="YYYY-MM-DD"
              ></datepicker>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Search Button -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="getFollowUps()">
              {{ $t('common.search') }}
              <b-icon-search class="ml-1"></b-icon-search>
            </b-button>
          </b-col>
        </b-row>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>
            {{ $t('common.table') }} {{ $t('office.tours') }} :{{
              $route.params.name
            }}
          </h2>
          <div>
            <b-button
              v-if="$store.state.app.permissions.includes('store-test')"
              variant="primary"
              @click="show(EditForm, 'create')"
            >
              {{ $t('common.create') }} {{ $t('office.tour') }}
            </b-button>
            <b-button class="m-1" @click="generateToursPdf()" variant="warning"
              >{{ $t('common.print') }} {{ $t('office.follow-up') }}</b-button
            >
          </div>
        </div>

        <b-table
          :items="this.data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <!-- Column: Actions -->

          <template #cell(actions)="data">
            <ActionsButtons
              deletePerm="delete-patient-doctor-note"
              editPerm="update-patient-doctor-note"
              @editToggle="show(data.item)"
              @deleteToggle="deleteModel(data.item)"
            />
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner :label="$t('common.loading')" />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >{{ $t('common.showing') }} 1 {{ $t('common.to') }} 10
                {{ $t('common.item') }}</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getFollowUps()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="patient card"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @hasStartedGeneration="hasStartedGeneration"
      @hasGenerated="hasGenerated"
      ref="html2PdfTimeDate"
    >
      <section dir="rtl" class="pdf-content font-modify m-5" slot="pdf-content">
        <h1 class="text-center">{{ $brand.nameArFull }}</h1>
        <h5 class="mt-2">:Patient Name : {{ $route.params.name }}</h5>
        <table style="width: 100%; table-layout: fixed">
          <thead>
            <tr>
              <th>Night Tour</th>
              <th>Morning Tour</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, rowIndex) in rows" :key="rowIndex">
              <td>
                <div>{{ row.nightDate }}</div>
                <div :style="{ height: '80px' }">{{ row.nightContent }}</div>
              </td>
              <td>
                <div>{{ row.morningDate }}</div>
                <div :style="{ height: '80px' }">{{ row.morningContent }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BFormTextarea,
} from 'bootstrap-vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import VueHtml2pdf from 'vue-html2pdf';

import permissionChecker from '@/mixins/permissionChecker';
import ActionsButtons from '@/components/common/ActionsButtons.vue';
import DeleteModal from '@/components/modals/DeleteModal.vue';
import { Datetime } from 'vue-datetime';
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select';

import 'vue-datetime/dist/vue-datetime.css';
export default {
  mixins: [permissionChecker],
  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BFormTextarea,
    VueHtml2pdf,
    Datetime,
    ActionsButtons,
    DeleteModal,
    Datepicker,
    vSelect,
  },
  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      data: [],
      date: new Date(Date.now()).toISOString(),
      EditForm: {
        date: '',
        conetnt: '',
        type: '',
        patient_card_id: this.$route.params.id,
        _method: 'PUT',
      },
      createMode: false,
      errorForm: {
        date: '',
        conetnt: '',
        type: '',
        patient_card_id: '',
      },
      params: {
        form: {},
        path: '',
      },
      tableColumns: [
        {
          key: 'type',
          label: this.$t('common.type'),
          sortable: true,
        },
        { key: 'content', label: this.$t('common.content'), sortable: true },
        { key: 'date', label: this.$t('common.date'), sortable: true },

        { key: 'Actions', label: this.$t('common.actions') },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: '',
      sortBy: 'id',
      isSortDirDesc: true,
      page: 1,
    };
  },
  mounted() {
    this.getFollowUps();
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);

      if (date) {
      }
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:00`;
    },
    generateToursPdf() {
      this.$refs.html2PdfTimeDate.generatePdf();
    },

    processData(apiData) {
      // Initialize the rows array
      const rows = [];

      // Filter and sort the data by type and date
      const nightTours = apiData
        .filter((item) => item.type === 'night')
        .sort((a, b) => new Date(a.date) - new Date(b.date));
      const morningTours = apiData
        .filter((item) => item.type === 'morning')
        .sort((a, b) => new Date(a.date) - new Date(b.date));

      // Determine the maximum number of rows needed
      const maxRows = Math.max(nightTours.length, morningTours.length);

      // Create rows with night and morning tour data
      for (let i = 0; i < maxRows; i++) {
        const nightDate = nightTours[i] ? `Date: ${nightTours[i].date}` : '';
        const nightContent = nightTours[i] ? nightTours[i].content : '';
        const morningDate = morningTours[i]
          ? `Date: ${morningTours[i].date}`
          : '';
        const morningContent = morningTours[i] ? morningTours[i].content : '';
        rows.push({
          nightDate,
          nightContent,
          morningDate,
          morningContent,
        });
      }

      // Update the rows data property
      this.rows = rows;
    },
    show(item, mode) {
      if (mode === 'create') {
        this.createMode = true;
        this.EditForm = {
          date: '',
          conetnt: '',
          type: '',
          patient_card_id: this.$route.params.id,
          _method: 'POST',
        };
      } else {
        this.createMode = false;
        this.EditForm.id = item.id;
        this.EditForm.content = item.content;
        this.EditForm.date = this.formatDate(item.date);
        this.EditForm.type = item.type;
        this.EditForm.patient_card_id = item.patient_card_id;
        this.EditForm._method = 'PUT';
      }
      this.$bvModal.show('modal-edit');
    },

    async getFollowUps() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/patientCardTour?filter[patient_card_id]=${this.$route.params.id}&include=patientCard&page=${this.page}&take=${this.take}&sort=-id`;

      if (this.typeFilter) {
        url += `&filter[type]=${this.typeFilter}`;
      }
      if (this.dateFilter) {
        url += `&filter[date]=${this.formatDate(this.dateFilter)}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.processData(this.data);

      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show('modal-delete');
    },
    deleteItem() {
      this.$store
        .dispatch('delete', `/patientCardTour/${this.deleteForm.id}`)
        .then((response) => {
          this.getFollowUps();

          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Delete Success',
              icon: 'success',
              variant: 'info',
              text: 'deleted ' + this.deleteForm.first_name + ' successfully',
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              variant: 'danger',
              text: 'Error deleting ' + this.deleteForm.first_name,
            },
          });
        });
    },
    submitItem() {
      for (let item in this.errorForm) {
        this.errorForm[item] = '';
        if (this.EditForm[item] == '' || this.EditForm[item] == null)
          delete this.EditForm[item];
      }
      this.EditForm.date = this.formatDate(Date.now());

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/patientCardTour`),
          this.$store
            .dispatch('create', this.params)
            .then((response) => {
              this.getFollowUps();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'validation error',
                      variant: 'danger',
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/patientCardTour/${this.EditForm.id}?_method=PUT`),
          this.$store
            .dispatch('update', this.params)
            .then((response) => {
              this.getFollowUps();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'validation error',
                      variant: 'danger',
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.mb-md-0 {
  margin-top: 8px;
}

table {
  width: 94%;
  border: 1px solid;
  font-size: 11px;
}

.no-border {
  border: 0;
}

.square-dark {
  background-color: rgba(0, 0, 0, 0.2);
}

tr,
th,
td {
  border: 1px solid;
  width: 10px;
  height: 10px;
  text-align: center;
}

.font-modify {
  letter-spacing: normal !important;
}

.pdf-table {
  page-break-inside: avoid;
}

.square {
  width: 30px;
  /* Smaller width for squares */
  height: 30px;
  /* Smaller height for squares */
  background-color: #000;
  /* Color of the square */
  display: inline-block;
  /* Allows us to set width and height */
}

.centered-text {
  text-align: center;
  border: 2px solid #000;
  /* Border for the cell */
}

#table-above {
  border-collapse: collapse;
  /* Removes space between borders */
  font-size: 12px;
  /* Smaller font size for the entire table */
}

@media print {
  @page {
  }

  .pdf-table {
    page-break-before: avoid;
    page-break-inside: avoid;
  }
}

.pdf-table:first-child {
  margin-top: 1em;
  /* Adjust the value as needed */
  page-break-inside: avoid;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
